<template>
  <div class="content-wrapper">
    <v-checkbox
      id="show-obsolete-tolldomains"
      hide-details
      on-icon="mdi-checkbox-intermediate"
      off-icon="mdi-checkbox-blank-outline"
      class="ma-0 pa-0"
      color="warning"
      dark
      @change="onObsoleteSelection"
    />
    <span class="show-obsolete-label">{{ $t('tolling.show_obsolete') }}</span>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['obsoleteSelection']);

function onObsoleteSelection(event: Event) {
  emit('obsoleteSelection', event);
}
</script>
<style lang="scss" scoped>
@import './styles/obsolete-selector.scss';
</style>
